import { LicenseService } from './../../services/license.service';
import {
  Component,
  ElementRef,
  HostListener,
  inject,
  ViewChild,
} from '@angular/core';
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';
import { RouterModule } from '@angular/router';
import Keycloak from 'keycloak-js';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { SidebarNavigationService } from '../../services/sidebar-navigation.service';

@Component({
  selector: 'app-sidebar',
  imports: [SidebarItemComponent, RouterModule, CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  keycloak = inject(Keycloak);
  LicenseService = inject(LicenseService);
  sidebarNavigationService = inject(SidebarNavigationService);
  isStaging = environment.staging;

  readonly primaryNavigationItems =
    this.sidebarNavigationService.getPrimaryItems();
  readonly secondaryNavigationItems =
    this.sidebarNavigationService.getSecondaryItems();

  logout() {
    this.keycloak.logout();
    this.LicenseService.removeActiveLicense();
  }

  // 1. Get reference to the scrollable div
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  // 2. Variable to toggle the text
  hasScrollbar: boolean = false;

  // 3. Check once the view is initialized
  ngAfterViewInit() {
    // Timeout ensures the DOM is fully rendered before calculating
    setTimeout(() => {
      this.checkScroll();
    }, 0);
  }

  // 4. Check again if the window is resized
  @HostListener('window:resize')
  onResize() {
    this.checkScroll();
  }

  // 5. Logic to compare scrollHeight vs clientHeight
  checkScroll() {
    if (this.scrollContainer) {
      const el = this.scrollContainer.nativeElement;

      // 1. Check if content is taller than the container (Scrollbar exists)
      const isScrollable = el.scrollHeight > el.clientHeight;

      // 2. Check if we are at the bottom
      // We use a small threshold (+1) to handle fractional pixel calculations in some browsers
      const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1;

      // 3. Show hint ONLY if it is scrollable AND we are NOT at the bottom
      this.hasScrollbar = isScrollable && !isAtBottom;
    }
  }

  scrollDown() {
    if (this.scrollContainer) {
      const el = this.scrollContainer.nativeElement;

      // Option A: Scroll down by 200 pixels (useful to see the next few items)
      el.scrollBy({ top: 200, behavior: 'smooth' });

      /* Option B: Scroll to the very bottom 
       el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
    */
    }
  }
}
